export default {
    BASE_URL: '',
    api: [
        {
            name: 'list',
            desc: '列表',
            method: 'GET',
            path: '/admin/crm/mem/cert/overview/initial'
        },
        {
            name: 'producing',
            desc: '制作中...',
            method: 'GET',
            path: '/admin/crm/mem/cert/overview/producing'
        },
        {
            name: 'ending',
            desc: '已完成列表',
            method: 'GET',
            path: '/admin/crm/mem/cert/overview/ending'
        },
        {
            name: 'delete',
            desc: '删除',
            method: 'DELETE',
            path: '/admin/crm/mem/cert/overview/remove/{id}'
        },
        {
            name: 'make',
            desc: '提交制作',
            method: 'PUT',
            path: '/admin/crm/mem/cert/overview/submit/{id}'
        },
        {
            name: 'undo',
            desc: '回退证书',
            method: 'PUT',
            path: '/admin/crm/mem/cert/overview/rollback/{id}'
        },
        {
            name: 'made',
            desc: '制作完成',
            method: 'PUT',
            path: '/admin/crm/mem/cert/overview/end/{id}'
        },
        {
            name: 'save',
            desc: '保存',
            method: 'POST',
            path: '/admin/crm/mem/cert/overview/save'
        },
        {
            name: 'submit',
            desc: '提交',
            method: 'POST',
            path: '/admin/crm/mem/cert/overview/submit'
        },
        {
            name: 'search',
            desc: '单位搜索',
            method: 'GET',
            path: '/admin/crm/mem/cert/overview/org_match'
        },
        {
            name: 'detail',
            desc: '获取详情',
            method: 'GET',
            path: '/admin/crm/mem/cert/overview/detail'
        },
        {
            name: 'type',
            desc: '获取证书类型',
            method: 'GET',
            path: '/pub/crm/mem/cert/type'
        }
    ]
  }
  


// WEBPACK FOOTER //
// ./src/api/cert/generate.js